export { VehicleCovered } from './VehicleCovered';
